import React from 'react';
import WName, {WArticle} from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2} from '../common';

// The human STANDARD
export const human_standard = {
  name: "human standard",
  alternatives: "human-standard",
  parentName: "the human standard",
  prelude: <span>
  </span>,
  header: <span>
    The human standard
  </span>,
  outside: <span>
    It has to do with <WName /> being a ‘<PL name="establishment">disestablishmentarian</PL>’ <AL>framework</AL>. It has to do with the <LRL>reality</LRL> of <NW>God</NW>’s literal <i><AL>war</AL></i> on <LRL>reactivity</LRL>. It has to do with the ‘<AL name="notnew.p.arendt">banality of evil</AL>’ – and the arrow of time and thermodynamics (ya know, <i><NW>entropy</NW></i>): that not-acting would be like a <QL>body</QL>’s liver deciding to just ‘take a break’, until I <i><PL name="comfort">feel better</PL></i>!!!11 It just leads us collectively to decay.
  </span>,
  preview: <div className="problem-preview">
    <p>The ‘human standard’ is a name for the ‘go with the flow’ nature of rejecting <NW word="overcome">Ganzesystemüberwindung</NW>. Settling to the LCD (lowest common denominator). Not <LRL name="kujifanya">daring to imagine</LRL>. Not being proactive, but <i><LRL name="reactivity">reactive</LRL></i>.</p>
    <p><WName cap /> is not <i>easy</i>, but it is <QL name="consistent.ya"><i>я</i>-consistent</QL>. It has the <LRL>answers</LRL>. Those are:</p>
    <ul>
      <li><AL>You</AL> have to <i>think</i>.</li>
      <li>No one OutThere<sup>®</sup> is going to <QL name="salvation">save us</QL></li>
      <li><NW>God</NW> is not <NW>GodEE</NW><sup>™</sup>, and not a Person<sup>™</sup>. It’s <i><QL>consciousness</QL></i>.</li>
      <li>The Devil is real, but not a horned Beast<sup>™</sup>. The  ‘Devil’ is <PL>privacy</PL>.</li>
      <li>Our current predicament (on <LRL>Earth</LRL>) can be <E2 suffix="ed" /> quite well by <NW word="jorm">Jörmungandr</NW>. </li>
      <li>Your <PL>individuality</PL> is just an <NW>illusion</NW>, but your <NW word="authenticity">barántúlacht</NW> is not. <QL name="integration">融入不是抹去</QL> if we are all <i>conscious</i> about our (<LRL name="gaia">planetary</LRL>) <QL>evolution</QL>.</li>
      <li>End <AL name="hell">separation</AL>. End <NW>apartheid</NW>. And <LRL name="kujifanya">dare to imagine</LRL>.</li>
    </ul>
  </div>,
//  text: <div className="problem-text">
//  </div>,
};
